/* House of Perna theme interactions: scissors cursor, scrap trail, wave ribbon,
   hotspots, print explorer, quick add, filters and the newsletter envelope. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Scissors cursor + fabric scraps ---------- */
  function initCursor() {
    var cur = document.querySelector('[data-hop-cursor]');
    if (!cur || !fine || document.documentElement.classList.contains('shopify-design-mode')) return;
    document.documentElement.classList.add('hop-has-cursor');
    var a = cur.querySelector('[data-blade-a]');
    var b = cur.querySelector('[data-blade-b]');
    var snip = document.querySelector('[data-hop-snip]');
    var scrapsOn = cur.getAttribute('data-scraps') === 'true' && !reduce;
    var colors = ['#EF5BA1', '#FAC9D3', '#0F90C0', '#16A08C', '#66CAD8', '#A6D8C0', '#EECEC1', '#E4414B', '#B89560'];
    var shapes = ['polygon(0 12%, 100% 0, 88% 100%, 6% 84%)', 'polygon(14% 0, 100% 22%, 78% 100%, 0 70%)', 'polygon(0 0, 100% 30%, 60% 100%)', 'polygon(50% 0,62% 38%,100% 50%,62% 62%,50% 100%,38% 62%,0 50%,38% 38%)'];
    var live = 0, MAX = 50, travel = 0, px = null, py = null, mx = -100, my = -100, lx = 0, ly = 0, down = false, hot = false, lastMove = 0, idleT = 0;

    function setOpen(d) {
      a.setAttribute('transform', 'rotate(' + d.toFixed(1) + ' 30 62)');
      b.setAttribute('transform', 'rotate(' + (-d).toFixed(1) + ' 30 62)');
    }
    function scrap(x, y) {
      if (!scrapsOn || live >= MAX) return;
      var el = document.createElement('span');
      var k = Math.floor(Math.random() * 5);
      var s = 6 + Math.random() * 9;
      el.className = 'hop-scrap';
      el.style.background = k === 3 ? '#B89560' : colors[Math.floor(Math.random() * colors.length)];
      if (k === 4) { el.style.width = '2px'; el.style.height = '12px'; el.style.borderRadius = '1px'; }
      else { el.style.width = (k === 3 ? s * 1.4 : s) + 'px'; el.style.height = (k === 3 ? s * 1.4 : s * 0.8) + 'px'; el.style.clipPath = shapes[k]; }
      document.body.appendChild(el);
      live++;
      var dx = (Math.random() - 0.5) * 60, dy = 40 + Math.random() * 70, rot = (Math.random() - 0.5) * 540;
      var anim = el.animate([
        { transform: 'translate(' + x + 'px,' + y + 'px) rotate(0deg) scale(1)', opacity: 1 },
        { transform: 'translate(' + (x + dx) + 'px,' + (y + dy) + 'px) rotate(' + rot + 'deg) scale(.4)', opacity: 0 }
      ], { duration: 800 + Math.random() * 700, easing: 'cubic-bezier(.2,.6,.4,1)' });
      anim.onfinish = function () { el.remove(); live--; };
    }
    function burst(n) { for (var i = 0; i < n; i++) scrap(mx - 14 + (Math.random() - 0.5) * 12, my - 14 + (Math.random() - 0.5) * 12); }

    document.addEventListener('mousemove', function (e) {
      cur.style.opacity = '1';
      cur.style.transform = 'translate(' + (e.clientX + 9) + 'px,' + (e.clientY - 18) + 'px)';
      mx = e.clientX; my = e.clientY;
      travel += Math.abs(mx - (px == null ? mx : px)) + Math.abs(my - (py == null ? my : py));
      px = mx; py = my; lastMove = Date.now();
      hot = !!(e.target.closest && e.target.closest('a,button,input,label,summary,select,[role="button"]'));
      if (!down) setOpen((hot ? 10 : 2) + 18 * Math.abs(Math.sin(travel / 38)));
      var dist = Math.abs(mx - lx) + Math.abs(my - ly);
      if (dist > 16) { burst(dist > 60 ? 3 : 1); lx = mx; ly = my; }
    }, { passive: true });
    document.addEventListener('mousedown', function (e) {
      down = true; setOpen(0); burst(9);
      if (snip) {
        snip.style.left = (e.clientX + 16) + 'px';
        snip.style.top = (e.clientY - 34) + 'px';
        snip.classList.add('is-on');
        clearTimeout(snip._t);
        snip._t = setTimeout(function () { snip.classList.remove('is-on'); }, 450);
      }
    });
    document.addEventListener('mouseup', function () { down = false; setOpen(hot ? 22 : 12); });
    document.addEventListener('mouseleave', function () { cur.style.opacity = '0'; });
    var lastS = 0;
    window.addEventListener('scroll', function () { var n = Date.now(); if (mx > 0 && n - lastS > 60) { lastS = n; burst(2); } }, { passive: true });
    setInterval(function () {
      if (down || Date.now() - lastMove < 400) return;
      idleT += 0.12;
      setOpen((hot ? 10 : 4) + 14 * Math.abs(Math.sin(idleT)));
    }, 60);
  }

  /* ---------- Wave ribbon (same method as amandaperna.com) ---------- */
  function initWaves(root) {
    (root || document).querySelectorAll('[data-hop-wave]').forEach(function (svg) {
      if (svg._hop) return; svg._hop = true;
      var tp = svg.querySelector('textPath');
      var unit = svg.querySelector('[data-wave-unit]');
      var speed = parseFloat(svg.getAttribute('data-speed') || '55');
      if (!tp || !unit) return;
      if (reduce) { document.documentElement.classList.add('hop-paused'); }
      var U = 0, o = 0, last = null;
      function frame(ts) {
        if (!U) { try { U = unit.getComputedTextLength(); } catch (e) { U = 0; } }
        if (last !== null && U && !document.documentElement.classList.contains('hop-paused')) { o = (o + (ts - last) / 1000 * speed) % U; tp.setAttribute('startOffset', (U - o).toFixed(1)); }
        last = ts;
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  /* ---------- Hotspots and print explorer ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-hop-hotspots]').forEach(function (wrap) {
      if (wrap._hop) return; wrap._hop = true;
      var spots = wrap.querySelectorAll('[data-hop-spot]');
      spots.forEach(function (spot) {
        var btn = spot.querySelector('button[data-spot-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = spot.classList.contains('is-open');
          spots.forEach(function (s) { s.classList.remove('is-open'); var t = s.querySelector('button[data-spot-toggle]'); if (t) t.setAttribute('aria-expanded', 'false'); });
          if (!open) { spot.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
          var img = wrap.querySelector('[data-zoom-target], .hop-zoom');
          if (img && wrap.classList.contains('is-zoomed')) img.style.transformOrigin = spot.style.left + ' ' + spot.style.top;
        });
      });
      wrap.querySelectorAll('[data-zoom]').forEach(function (z) {
        z.addEventListener('click', function () {
          var on = z.getAttribute('data-zoom') === 'in';
          wrap.classList.toggle('is-zoomed', on);
          var openSpot = wrap.querySelector('[data-hop-spot].is-open');
          var img = wrap.querySelector('[data-zoom-target], .hop-zoom');
          if (img) img.style.transformOrigin = openSpot ? (openSpot.style.left + ' ' + openSpot.style.top) : '50% 50%';
          wrap.querySelectorAll('[data-zoom]').forEach(function (o) { o.setAttribute('aria-pressed', o === z ? 'true' : 'false'); });
        });
      });
    });
  }

  /* ---------- Quick add (falls back to a normal form post) ---------- */
  function initQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-hop-quick-add]')) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.getAttribute('data-label') || btn.textContent : '';
      if (btn) { btn.disabled = true; }
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = btn.getAttribute('data-added') || 'An excellent decision.'; btn.classList.add('is-added'); }
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-hop-bag-count], .cart-bubble__text-count').forEach(function (n) { n.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('hop:cart-updated', { detail: cart }));
        })
        .catch(function () { if (btn) { btn.textContent = btn.getAttribute('data-soldout') || "She's already left the party."; } })
        .finally(function () { if (btn) { btn.disabled = false; setTimeout(function () { btn.textContent = original; btn.classList.remove('is-added'); }, 3200); } });
    });
  }

  /* ---------- Rail filters ---------- */
  function initFilters(root) {
    (root || document).querySelectorAll('[data-hop-filters]').forEach(function (wrap) {
      if (wrap._hop) return; wrap._hop = true;
      var section = wrap.closest('section') || document;
      wrap.querySelectorAll('button[data-filter]').forEach(function (b) {
        b.addEventListener('click', function () {
          var f = b.getAttribute('data-filter');
          wrap.querySelectorAll('button[data-filter]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          section.querySelectorAll('[data-type]').forEach(function (card) {
            var t = (card.getAttribute('data-type') || '').toLowerCase();
            card.hidden = !(f === 'all' || t.indexOf(f) !== -1);
          });
        });
      });
    });
  }

  function initSound(root) {
    (root || document).querySelectorAll('[data-hop-sound]').forEach(function (b) {
      if (b._hop) return; b._hop = true;
      var sec = b.closest('section');
      b.addEventListener('click', function () {
        var v = sec && sec.querySelector('video'); if (!v) return;
        v.muted = !v.muted; if (!v.muted) { v.play(); }
        b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        b.textContent = v.muted ? 'Sound on' : 'Sound off';
      });
    });
  }


  /* ---------- Video and motion controls (WCAG 2.2.2 pause, stop, hide) ---------- */
  function hopVideos(root) { return (root || document).querySelectorAll('.hop video'); }
  function setPaused(on) {
    document.documentElement.classList.toggle('hop-paused', on);
    hopVideos().forEach(function (v) { if (on) { v.pause(); } else { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    document.querySelectorAll('[data-hop-motion]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? 'Play motion' : 'Pause motion'; });
    document.querySelectorAll('[data-hop-pause]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? 'Play' : 'Pause'; b.setAttribute('aria-label', on ? 'Play video' : 'Pause video'); });
  }
  function initMotion(root) {
    if (reduce && !initMotion._done) { initMotion._done = true; setTimeout(function () { setPaused(true); }, 0); }
    (root || document).querySelectorAll('[data-hop-motion], [data-hop-pause]').forEach(function (b) {
      if (b._hop) return; b._hop = true;
      b.addEventListener('click', function () {
        if (b.hasAttribute('data-hop-pause')) {
          var v = b.closest('section') && b.closest('section').querySelector('video');
          if (!v) return;
          if (v.paused) { v.play(); b.textContent = 'Pause'; b.setAttribute('aria-label', 'Pause video'); b.setAttribute('aria-pressed', 'false'); }
          else { v.pause(); b.textContent = 'Play'; b.setAttribute('aria-label', 'Play video'); b.setAttribute('aria-pressed', 'true'); }
        } else {
          setPaused(!document.documentElement.classList.contains('hop-paused'));
        }
      });
    });
  }

  /* ---------- Join the party: confetti when someone signs up ---------- */
  function initParty(root) {
    (root || document).querySelectorAll('[data-hop-envelope]').forEach(function (env) {
      if (env._hop) return; env._hop = true;
      if (!env.querySelector('[data-hop-joined]')) return;
      env.classList.add('is-open');
      if (reduce) return;
      var r = env.getBoundingClientRect();
      var colors = ['#EF5BA1', '#FAC9D3', '#FFFDF9', '#66CAD8', '#121212', '#B89560'];
      for (var i = 0; i < 70; i++) {
        var b = document.createElement('span');
        b.className = 'hop-party__confetti-bit';
        b.style.background = colors[i % colors.length];
        b.style.left = (r.left + r.width / 2) + 'px'; b.style.top = (r.top + 80) + 'px';
        document.body.appendChild(b);
        var dx = (Math.random() - 0.5) * 600, dy = -150 - Math.random() * 260, rot = Math.random() * 720;
        var a = b.animate([{ transform: 'translate(0,0) rotate(0)', opacity: 1 }, { transform: 'translate(' + dx + 'px,' + (dy + 520) + 'px) rotate(' + rot + 'deg)', opacity: 0 }], { duration: 1600 + Math.random() * 900, easing: 'cubic-bezier(.2,.7,.4,1)' });
        a.onfinish = (function (el) { return function () { el.remove(); }; })(b);
      }
    });
  }

  /* ---------- Contact: preselect a topic from ?topic= in the link ---------- */
  function initTopic() {
    var sel = document.querySelector('[data-hop-topic]'); if (!sel) return;
    var m = location.search.match(/[?&]topic=([^&]+)/); if (!m) return;
    var want = decodeURIComponent(m[1].replace(/\+/g, ' ')).toLowerCase();
    for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].value.toLowerCase().indexOf(want) === 0) { sel.selectedIndex = i; break; } }
  }

  function init(root) { initTopic(); initParty(root); initMotion(root); initSound(root); initWaves(root); initHotspots(root); initFilters(root); }

  document.addEventListener('DOMContentLoaded', function () { initCursor(); initQuickAdd(); init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
